import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Button as ButtonMUI } from '@mui/material';

export const LinkedInLogin = styled(ButtonMUI)`
  height: 38px;
  color: white;
  background-color:  #0A66C2;
  &:hover {
    background: #0A66C2;
    color: white;
  }
`;
